import { JwtHelperService } from "@auth0/angular-jwt";

export const default_headers: { [key: string]: string } = {};

export const TOKEN_STORE_ITEM_NAME = "jwt_wicked";

export function getAuthToken(): string {
  return localStorage.getItem(TOKEN_STORE_ITEM_NAME);
}

export function setAuthToken(token: string | undefined) {
  if (token && token != "") {
    localStorage.setItem(TOKEN_STORE_ITEM_NAME, token);
  } else {
    localStorage.removeItem(TOKEN_STORE_ITEM_NAME);
  }
}

export function isTokenExpired() {
  var myRawToken = getAuthToken();
  if (myRawToken) {
    const helper = new JwtHelperService();
    const isExpired = helper.isTokenExpired(myRawToken);
    return isExpired;
  } else {
    return true;
  }
}

export function isAuthenticated() {
  var myRawToken = getAuthToken();
  if (myRawToken) {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(myRawToken);

    const expirationDate = helper.getTokenExpirationDate(myRawToken);
    const isExpired = helper.isTokenExpired(myRawToken);
    return !isExpired;
  } else {
    return false;
  }
}

export function getUserTokenField(fieldName: string) {
  //http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname
  if (isAuthenticated()) {
    var myRawToken = getAuthToken();
    if (myRawToken && fieldName && fieldName != "") {
      const helper = new JwtHelperService();
      const decodedToken = helper.decodeToken(myRawToken);
      return decodedToken[fieldName] ? decodedToken[fieldName] : "";
    } else {
      return "";
    }
  } else return "";
}

export function getUserTokenFieldSchema(fieldName: string) {
  //surname
  if (isAuthenticated()) {
    var myRawToken = getAuthToken();
    if (myRawToken && fieldName && fieldName != "") {
      const helper = new JwtHelperService();
      const decodedToken = helper.decodeToken(myRawToken);
      if (fieldName == "primarysid" || fieldName == "role") {
        fieldName = `http://schemas.microsoft.com/ws/2008/06/identity/claims/${fieldName}`;
      } else {
        fieldName = `http://schemas.xmlsoap.org/ws/2005/05/identity/claims/${fieldName}`;
      }
      return decodedToken[fieldName] ? decodedToken[fieldName] : "";
    } else {
      return "";
    }
  } else return "";
}
